import { parsePhoneNumberFromString } from 'libphonenumber-js';
export default function phoneParser(candidate, country) {
  return parsePhoneNumberFromString(candidate || '', country);
}